import { useState } from "react";
import useCopilotChat from "./copilot/useCopilotChat";
import CopilotHeader from "./copilot/CopilotHeader";
import CopilotSidebar from "./copilot/CopilotSidebar";
import CopilotMessages from "./copilot/CopilotMessages";
import CopilotInput from "./copilot/CopilotInput";

export default function CopilotPanel({ onClose }) {
  const {
    messages,
    streaming,
    sessions,
    activeSessionId,
    startNewChat,
    loadSession,
    deleteSession,
    send,
  } = useCopilotChat();
  const [showSidebar, setShowSidebar] = useState(false);

  const onLoadSession = (sid) => { if (!streaming) loadSession(sid); };

  return (
    <aside
      data-testid="copilot-panel"
      className="w-[460px] flex-shrink-0 border-l border-zinc-950 flex flex-col bg-white"
    >
      <CopilotHeader
        showSidebar={showSidebar}
        onToggleSidebar={() => setShowSidebar((v) => !v)}
        onNewChat={startNewChat}
        onClose={onClose}
      />
      <div className="flex-1 flex overflow-hidden">
        {showSidebar && (
          <CopilotSidebar
            sessions={sessions}
            activeSessionId={activeSessionId}
            onLoad={onLoadSession}
            onDelete={deleteSession}
          />
        )}
        <div className="flex-1 flex flex-col">
          <CopilotMessages messages={messages} streaming={streaming} onSuggestion={send} />
          <CopilotInput disabled={streaming} activeSessionId={activeSessionId} onSend={send} />
        </div>
      </div>
    </aside>
  );
}
